/**
 * Section: Image banner -- triple
 * ------------------------------------------------------------------------------
 * Large component displaying three images as CTAs
 *
 * @namespace imageBannerTriple
 */
import { register } from '@shopify/theme-sections';
import { debounce, on } from '~/helpers/utils';
/**
 * DOM selectors.
 */

const selectors = {
  id: 'ImageBannerTriple'
};
let container;
/**
 * Image slider section constructor.
 * Executes on page load as well as Theme Editor `section:load` events.
 */

register('homepage-image-banner--triple', {
  /**
   * Cache selectors.
   * - Define necessary variables and make available for component use.
   */
  cacheSelectors() {
    container = "#".concat(selectors.id, "-").concat(this.id);
    this.cache = {
      container
    };
  },

  /**
   * Set cached node selectors.
   */
  setNodeSelectors() {
    container = document.querySelector(this.cache.container);
  },

  /**
   * Event callback when Section is registered in scripts.
   */
  onLoad() {
    this.cacheSelectors();
    this.setNodeSelectors();
    this.setHeight();
    this.setResizeEventListener();
  },

  setHeight() {
    if (container.offsetWidth > 768) {
      container.style.height = "".concat(container.offsetWidth * 0.52, "px");
      return;
    }

    container.style.height = "".concat(container.offsetWidth * 2.38, "px");
  },

  /**
   * Set resize listeners
   */
  setResizeEventListener() {
    on('resize', debounce(this.setHeight, 500));
  }

});